export class PikabuGuestSession {
    private static readonly AUTHORIZATION_KEY = 'aof_pikabu_guest_authorization';

    public static getAuthorization(): string | null {
        try {
            return window.localStorage.getItem(PikabuGuestSession.AUTHORIZATION_KEY);
        } catch (e) {
            return null;
        }
    }

    public static setAuthorization(token: string): void {
        try {
            window.localStorage.setItem(PikabuGuestSession.AUTHORIZATION_KEY, token);
        } catch (e) {
            // Storage can be unavailable in a third-party iframe.
        }
    }

    public static clearAuthorization(): void {
        try {
            window.localStorage.removeItem(PikabuGuestSession.AUTHORIZATION_KEY);
        } catch (e) {
            // Storage can be unavailable in a third-party iframe.
        }
    }
}
